import { render, staticRenderFns } from "./AddContactToListModal.vue?vue&type=template&id=129b916e&"
import script from "./AddContactToListModal.vue?vue&type=script&lang=js&"
export * from "./AddContactToListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports